
export default {
  methods: {
    updatePositionIndex (items) {
      items.forEach((el, index) => {
        el.index = index + 1
        el.editIndex = true
      })
    },
    totalPercentSteps (steps) {
      return steps.reduce((accumulator, item) => {
        const { percent } = item
        return accumulator + percent
      }, 0)
    },
    isValidStep (steps) {
      const isError = steps.some((el) => el.error)
      if (isError) return true
      const total = this.totalPercentSteps(steps)
      return total !== 100
    },
    validation (item, steps) {
      const { name, _id, isEdit } = item
      if (!name) this.$set(item, 'error', 'mandatory field')
      const isError = steps.some((el) => el.name === name && el._id !== _id)
      if (isError && isEdit) this.$set(item, 'error', 'The step name has already been created')
    },
    createBodyStep ({steps, _id}) {
      let addSteps = []
      const removeSteps = steps.filter((el) => el.isRemove)
      let updatedSteps = []
      const noRemoveSteps = steps.filter((el) => !el.isRemove)
      this.updatePositionIndex(noRemoveSteps)
      noRemoveSteps.forEach((item) => {
        this.validation(item, noRemoveSteps)
        const { isNew, isEdit, isEditColor, editIndex, isEditPercent } = item

        if (isNew) {
          addSteps.push({...item, _id: undefined})
        } else if (isEdit || isEditColor || editIndex || isEditPercent) {
          updatedSteps.push(item)
        }
      })

      return {
        addSteps,
        removeSteps: removeSteps.length ? removeSteps.filter((el) => !el.isNew).map((el) => el._id) : [],
        updatedSteps,
        typeService: _id,
        noRemoveSteps
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/createBodyTypeServiceProject.js